import { doc, getDocFromServer } from "firebase/firestore";
import { db } from "../firebase";
import { isNodeBookingAvailable } from "./nodeAvailability";

export const NODE_BOOKING_UNAVAILABLE_MESSAGE =
  "This node is not accepting new bookings. Please select another node.";

// Use the current server value. Rules check again when the event is written.
export const assertNodeAcceptsNewBooking = async (nodeId) => {
  if (!nodeId) throw new Error("Please select a valid node before creating a booking.");
  const snapshot = await getDocFromServer(doc(db, "nodes", nodeId));
  if (!snapshot.exists() || !isNodeBookingAvailable(snapshot.data())) {
    const error = new Error(NODE_BOOKING_UNAVAILABLE_MESSAGE);
    error.code = "node-unavailable";
    throw error;
  }
};
